function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import Modal from "../Modal";
import { PeopleRoleSelectContext } from "./context";
import PeopleRoleSelectContent from "./PeopleRoleSelectContent";
import { PlusSquareOutlined } from '@ant-design/icons';
import { useUpdateEffect } from 'ahooks';
import { Space, Tag, Tooltip } from 'antd';
import cx from 'classnames';
import { isEqual, isUndefined } from 'lodash-es';
import Trigger from 'rc-trigger';
import React, { useEffect, useRef, useState } from 'react';
import "./index.css";
var PeopleRoleSelect = function PeopleRoleSelect(props) {
  var _props$disabledToolti = props.disabledTooltip,
    disabledTooltip = _props$disabledToolti === void 0 ? '仅管理员可设置' : _props$disabledToolti,
    _props$needCustom = props.needCustom,
    needCustom = _props$needCustom === void 0 ? true : _props$needCustom,
    groupData = props.groupData,
    memberData = props.memberData,
    modalProps = props.modalProps,
    outerGroupNodes = props.groupNodes,
    outerMemberNodes = props.memberNodes,
    onChange = props.onChange,
    visible = props.visible,
    onClose = props.onClose,
    _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'modal' : _props$mode,
    _onOk = props.onOk,
    disabled = props.disabled,
    className = props.className,
    selectPopupClassName = props.selectPopupClassName,
    style = props.style,
    selectPopupStyle = props.selectPopupStyle,
    value = props.value;
  var _useState = useState({
      groupNodes: undefined,
      memberNodes: undefined
    }),
    _useState2 = _slicedToArray(_useState, 2),
    list = _useState2[0],
    setList = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    memberNodes = _useState4[0],
    setMemberNodes = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    groupNodes = _useState6[0],
    setGroupNodes = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    open = _useState8[0],
    setOpen = _useState8[1];
  var _useState9 = useState(200),
    _useState10 = _slicedToArray(_useState9, 2),
    selectHeight = _useState10[0],
    setSelectHeight = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    selectWidth = _useState12[0],
    setSelectWidth = _useState12[1];
  var wrapperRef = useRef(null);
  useEffect(function () {
    if (Array.isArray(outerMemberNodes)) {
      setMemberNodes(outerMemberNodes);
    }
  }, [outerMemberNodes]);
  useEffect(function () {
    if (Array.isArray(outerGroupNodes)) {
      setGroupNodes(outerGroupNodes);
    }
  }, [outerGroupNodes]);
  useEffect(function () {
    if (open && wrapperRef.current !== null) {
      var dom = wrapperRef.current;
      var rect = dom.getBoundingClientRect();
      // 48是下拉菜单头部的长度 10是预留的边距
      var calcSelectHeight = document.body.offsetHeight - rect.bottom - 48 - 10;
      setSelectWidth(dom.clientWidth);
      // 500 是下拉框的最大长度
      setSelectHeight(calcSelectHeight > 500 ? 500 : calcSelectHeight);
    }
  }, [open]);
  useUpdateEffect(function () {
    onChange === null || onChange === void 0 || onChange(list);
  }, [list]);
  useEffect(function () {
    if (!isUndefined(value)) {
      var memberNodesInValue = value.memberNodes,
        groupNodesInValue = value.groupNodes;
      if (!isEqual(memberNodesInValue, memberNodes) && Array.isArray(memberNodesInValue)) {
        setMemberNodes(memberNodesInValue);
      }
      if (!isEqual(groupNodesInValue, groupNodes) && !isUndefined(groupNodesInValue)) {
        setGroupNodes(groupNodesInValue);
      }
    }
  }, [value]);
  var handleChangeNodes = function handleChangeNodes(type, data) {
    if (type === 'member') {
      setMemberNodes(data);
      var temp = {
        memberNodes: data.map(function (item) {
          return {
            id: item.id,
            name: item.completeName,
            completeName: item.completeName,
            pernr: item.id,
            nameEn: item.completeName.split('-')[0],
            nameZh: item.completeName.split('-')[1]
          };
        }),
        groupNodes: groupNodes.map(function (item) {
          return {
            id: item.id,
            name: item.completeName,
            completeName: item.completeName
          };
        })
      };
      setList(temp);
    } else {
      setGroupNodes(data);
      var _temp = {
        memberNodes: memberNodes.map(function (item) {
          return {
            id: item.id,
            name: item.completeName,
            completeName: item.completeName,
            pernr: item.id,
            nameEn: item.completeName.split('-')[0],
            nameZh: item.completeName.split('-')[1]
          };
        }),
        groupNodes: data.map(function (item) {
          return {
            id: item.id,
            name: item.completeName,
            completeName: item.completeName
          };
        })
      };
      setList(_temp);
    }
  };
  var isEmpty = function isEmpty() {
    return groupNodes.length === 0 && memberNodes.length === 0;
  };
  var renderNodes = function renderNodes() {
    var memberCom = memberNodes.map(function (node) {
      return /*#__PURE__*/React.createElement(Tag, {
        id: node.id,
        key: node.id,
        closable: !disabled,
        onClose: function onClose() {
          if (disabled) {
            return;
          }
          var findIdx = memberNodes.findIndex(function (item) {
            return item.id === node.id;
          });
          if (findIdx > -1) {
            setMemberNodes(function (prevState) {
              prevState.splice(findIdx, 1);
              handleChangeNodes('member', _toConsumableArray(prevState));
              return _toConsumableArray(prevState);
            });
          }
        }
      }, node.completeName);
    });
    var groupsCom = groupNodes.map(function (node) {
      return /*#__PURE__*/React.createElement(Tag, {
        id: String(node.id),
        key: node.id,
        closable: !disabled,
        onClose: function onClose() {
          if (disabled) {
            return;
          }
          var findIdx = groupNodes.findIndex(function (item) {
            return item.id === node.id;
          });
          if (findIdx > -1) {
            setGroupNodes(function (prevState) {
              prevState.splice(findIdx, 1);
              handleChangeNodes('groups', _toConsumableArray(prevState));
              return _toConsumableArray(prevState);
            });
          }
        }
      }, node.name);
    });
    return memberCom.concat(groupsCom);
  };
  var renderContentByMode = function renderContentByMode() {
    var componentName = 'dr-people-role-select';
    if (mode === 'select') {
      return /*#__PURE__*/React.createElement(Tooltip, {
        title: !disabled || disabledTooltip === false ? undefined : disabledTooltip
      }, /*#__PURE__*/React.createElement("div", {
        style: style,
        className: cx(className, componentName, disabled && 'disabled'),
        ref: wrapperRef
      }, /*#__PURE__*/React.createElement(Trigger, {
        action: ['click'],
        destroyPopupOnHide: true,
        popupClassName: cx(selectPopupClassName, 'dr-people-role-select-popup'),
        popupStyle: _objectSpread(_objectSpread({}, selectPopupStyle), {}, {
          width: (selectPopupStyle === null || selectPopupStyle === void 0 ? void 0 : selectPopupStyle.width) || selectWidth
        }),
        onPopupVisibleChange: function onPopupVisibleChange(tempVisible) {
          setOpen(tempVisible);
          if (!tempVisible) {
            onClose === null || onClose === void 0 || onClose();
          }
        },
        popupVisible: disabled ? false : open,
        popupAlign: {
          points: ['tl', 'bl'],
          offset: [0, 3]
        }
        // getPopupContainer={(trigger) => {
        //   return trigger.parentNode as any;
        // }}
        ,
        popup: /*#__PURE__*/React.createElement(PeopleRoleSelectContent, {
          selectWidth: selectWidth
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: cx("".concat(componentName, "-body"), isEmpty() && 'no-member')
      }, isEmpty() ? /*#__PURE__*/React.createElement(Space, {
        className: "".concat(componentName, "-select-container")
      }, /*#__PURE__*/React.createElement(PlusSquareOutlined, null), "\u70B9\u51FB\u9009\u62E9\u6210\u5458") : /*#__PURE__*/React.createElement(React.Fragment, null, renderNodes())))));
    }
    return /*#__PURE__*/React.createElement(Modal, {
      wrapClassName: className,
      style: style,
      fixHeight: true,
      open: visible,
      onCancel: onClose,
      onOk: function onOk() {
        _onOk === null || _onOk === void 0 || _onOk({
          memberNodes: memberNodes,
          groupNodes: groupNodes
        });
      },
      title: (modalProps === null || modalProps === void 0 ? void 0 : modalProps.title) || '添加人员',
      width: 900,
      okText: (modalProps === null || modalProps === void 0 ? void 0 : modalProps.okText) || '保存',
      okButtonProps: {
        disabled: isEmpty()
      }
    }, /*#__PURE__*/React.createElement(PeopleRoleSelectContent, null));
  };
  useEffect(function () {
    if (!isUndefined(visible)) {
      setOpen(visible);
    }
  }, [visible]);
  return /*#__PURE__*/React.createElement(PeopleRoleSelectContext.Provider, {
    value: {
      needCustom: needCustom,
      roleData: groupData,
      memberData: memberData,
      memberNodes: memberNodes,
      groupNodes: groupNodes,
      changeNodes: handleChangeNodes,
      selectHeight: selectHeight,
      mode: mode
    }
  }, renderContentByMode());
};
export default PeopleRoleSelect;